export const VehicleEnum = Object.freeze({
    car: "car",
    motorbike: "motorcycle",
    bicycle: "bike",
    walk: "foot"
})